function createRichTextV2Plugin({
  control,
  withPlugin,
  onKeyDown,
  renderElement,
  renderLeaf
}) {
  return { control, withPlugin, onKeyDown, renderElement, renderLeaf };
}
export {
  createRichTextV2Plugin
};
//# sourceMappingURL=plugin.js.map